import styled from "styled-components";
import {
  ResponsiveContainer,
  AreaChart,
  Tooltip,
  Area,
  CartesianGrid,
  YAxis,
  XAxis,
  ReferenceLine,
} from "recharts";
import { useEffect, useState } from "react";
import { PeakChartProps } from "../../../constants/types";
import { dateFormatter, formatNumber } from "../../../constants/function";
import { useMediaQuery } from "react-responsive";
import { format } from "date-fns";
import { CLOUDN_COLORS, COLORS } from "../../../constants/colors";

const PeakChart = (props: PeakChartProps) => {
  const [ticks, setTicks] = useState(0);
  const fhd = useMediaQuery({ maxDeviceWidth: 2000 });
  const date = format(new Date(), "yyyy-MM-dd");

  const error = console.error;
  console.error = (...args: any) => {
    if (/defaultProps/.test(args[0])) return;
    error(...args);
  }; // defaultProps 경고문 제거

  useEffect(() => {
    // const target = 6000;
    if (props.target < 7400) {
      const target = Number(props.target) + 1000;
      const tick = Math.round(target / 8 / 100) * 100;
      setTicks(tick);
    } else if (props.target < 11000) {
      setTicks(1500);
    } else if (props.target < 15000) {
      setTicks(2000);
    } else {
      setTicks(3000);
    }
  }, [props.target]);

  const ReferenceLabel = (props: {
    fill: any;
    textAnchor: any;
    fontSize: any;
    dy: any;
    dx: any;
    value: any;
  }) => {
    const { fill, fontSize, dy, dx, textAnchor, value } = props;
    return (
      <text
        dy={dy}
        dx={dx}
        fill={fill}
        fontSize={fontSize}
        textAnchor={textAnchor}
      >
        {value}
      </text>
    );
  };

  return (
    <Container>
      <ResponsiveContainer width="100%" height="98%">
        <AreaChart
          data={props.data}
          margin={
            fhd
              ? { top: 30, right: 20, left: 10, bottom: 0 }
              : { top: 50, right: 40, left: 10, bottom: 0 }
          }
        >
          <XAxis
            dataKey="date"
            tickFormatter={dateFormatter}
            tickLine={false}
            axisLine={false}
            tick={{
              stroke: COLORS.fontColor,
            }}
            fontSize={"0.8em"}
            fontWeight={300}
            ticks={[
              `${date} 00:15`,
              `${date} 03:00`,
              `${date} 06:00`,
              `${date} 09:00`,
              `${date} 12:00`,
              `${date} 15:00`,
              `${date} 18:00`,
              `${date} 21:00`,
              "24:00",
            ]}
          />
          <YAxis
            tickFormatter={formatNumber}
            tickCount={9}
            tick={{ stroke: COLORS.fontColor }}
            fontSize={"0.8em"}
            fontWeight={300}
            // interval={0}
            ticks={[
              0,
              ticks,
              ticks * 2,
              ticks * 3,
              ticks * 4,
              ticks * 5,
              ticks * 6,
              ticks * 7,
              ticks * 8,
            ]}
            tickLine={false}
            axisLine={false}
            label={{
              value: "kw",
              offset: 10,
              dx: 35,
              angle: 0,
              position: "top",
              fontSize: "0.6vw",
              fill: "#b4b4b4",
            }}
          />

          <CartesianGrid
            strokeOpacity={0.7}
            strokeDasharray="3 3"
            vertical={false}
          />
          <Tooltip
            formatter={formatNumber}
            labelFormatter={dateFormatter}
            separator="  "
            itemStyle={{
              color: "black",
              fontSize: "0.8vw",
              fontWeight: 600,
              border: `solid 0.15vw ${CLOUDN_COLORS.logoBlue} `,
              borderTop: "none",
              background: "white",
            }}
            wrapperStyle={{
              color: `${COLORS.lightBlack}`,
              fontWeight: "bold",
              textAlign: "center",
              background: "transparent",
            }}
            contentStyle={{
              background: "transparent",
              border: "none",
              // width: "6vw",
              // height: "4vh",
              // background: `#f8e494`,
              // borderColor: "#ffd050",
              // borderWidth: 2,
            }}
            labelStyle={{
              width: "8vw",
              border: `solid 0.15vw ${CLOUDN_COLORS.logoBlue} `,
              height: "40%",
              position: "relative",
              background: CLOUDN_COLORS.logoBlue,
              fontSize: "0.9vw",
              color: "white",
              paddingTop: "2%",
            }}
          />

          <ReferenceLine
            className="line"
            y={props.target}
            label={
              <ReferenceLabel
                dy="6%"
                dx="96%"
                fill={"red"}
                fontSize="0.7vw"
                textAnchor="end"
                value="— 목표치"
              />
            }
            // label="목표치"
            stroke={"red"}
            strokeWidth={"0.13vw"}
            fontSize="1vw"
            fill="red"
            textAnchor="end"
          />
          <Area
            type="monotone"
            activeDot={{ stroke: "#FFB900", strokeWidth: 1, r: 3 }}
            dataKey="value"
            stroke="#FFB900"
            strokeWidth={2}
            fill="#FFEA96"
            name="⚡ 피크"
            dot={{ width: 1, stroke: "#FFB900", strokeWidth: 4, r: 1 }}
          />
        </AreaChart>
      </ResponsiveContainer>
    </Container>
  );
};

export default PeakChart;

const Container = styled.div`
  width: 65%;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;

  .recharts-dot:not(:last-child) {
    display: none;
  }
`;
